import React, { useEffect } from "react";
import { Router, Redirect } from "@reach/router";
import { Provider, useSelector, useDispatch } from "react-redux";
import store from "./../redux/store/store";
import { getLanguages, getDictionary } from "../redux/actions/language.action";
import { Language } from "../redux/store/base/language";

// Pages
import Routes from "./route";

// Components
import SEO from "../components/Base/SEO";

// Style
import "bootstrap-css-only/css/bootstrap.min.css";
import "../../node_modules/mdbreact/dist/scss/mdb.scss";
import "./../assets/scss/index.scss";

const IndexPage = () => (
  <>
    <RoutesAPP />
    <SEO title={"Rooh"} />
  </>
);

const RoutesAPP = (props: any) => {
  const dispatch = useDispatch();
  const state = useSelector((state: { lang: Language }) => state);

  useEffect(() => {
    if (!state?.lang.languages) dispatch(getLanguages());
  }, []);
  useEffect(() => {
    if (!state?.lang.dictionary)
      dispatch(getDictionary(state?.lang.caruentLanguage.id));
    else if (state?.lang.dictionary.__id == state?.lang.caruentLanguage.id)
      dispatch(getDictionary(state?.lang.caruentLanguage.id));
  }, [state?.lang?.caruentLanguage]);

  if (state?.lang?.dictionary)
    return (
      <Router>
        {Routes(
          ConverPropertyFromJsonToObject(state?.lang.dictionary.pagesTitle)
        ).map(
          (item: { component: any; path: string; title: string }, i: number) =>
            item && (
              <item.component key={i} path={item.path} title={item.title} />
            )
        )}
        <Redirect noThrow path="/" from="/" to="signin" />
        <Redirect noThrow path="*" from="*" to="/404" />
      </Router>
    );
  else return <div>Loading...</div>;
};

const ConverPropertyFromJsonToObject = (
  items: any
): Array<{
  id: string;
  title: string;
}> => {
  var pagesTitle: Array<{
    id: string;
    title: string;
  }> = new Array<{
    id: string;
    title: string;
  }>();
  for (let item in items) {
    pagesTitle.push({
      id: item,
      title: items[item],
    });
  }
  return pagesTitle;
};

export default IndexPage;
